import React, { useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import SubTitle from "../../components/SubTitle";
import DangerEvaluationForm from "./DangerEvaluationForm";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import { useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackBarState, snackBarToggleState } from "../../Recoil/Atom/snackBarState";
import { tokenSelector } from "../../Recoil/Atom/authState";
import { useCreateMutation, useGetItemQuery } from "../../hooks/useQueryHooks";
import { ResponseItem } from "../../models/clientModels/interfaces/Response";
import {
  WPDangerEvaluation,
  initializeDangerEvaluation,
} from "../../models/serverModels/permission/WPDangerEvaluation";

import * as dangerEvaluationApi from "../../api/permissionApi/dangerEvaluationApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import MWProgress from "../../components/MWProgress";
import { FormSection } from "../../styledComponents/StyledCreateForm";
import { Button } from "@mui/material";
const CreateDangerEvaluation = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const { data: DangerNewEvaluation, isLoading: isGetLoading } = useGetItemQuery<
    ResponseItem<WPDangerEvaluation>
  >({
    key: ["DangerNewEvaluation", id],
    api: () => dangerEvaluationApi.getCreate2({ token: tokenState, id: parseInt(id!) }),
    options: { refetchOnWindowFocus: false }
  });

  console.log("⚾ ~ CreateDangerEvaluation ~ DangerNewEvaluation:", DangerNewEvaluation);
  const {
    mutate: createMutate,
    isLoading,
    data: res,
  } = useCreateMutation<ResponseItem<WPDangerEvaluation>, Params.Create<WPDangerEvaluation>>({
    api: dangerEvaluationApi.create,
    options: {
      onSuccess: async (res: ResponseItem<WPDangerEvaluation>) => {
        setSnackBarToggle(true);
        setSnackBarState("create");

        navigate(`/Permission/CheckPermission/${res?.item?.uid}`);
        queryClient.invalidateQueries("DangerEvaluationList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<WPDangerEvaluation>({
    defaultValues: DangerNewEvaluation?.item || initializeDangerEvaluation(parseInt(id!)),
  });
  const { reset } = methods;

  useEffect(() => {
    reset(DangerNewEvaluation?.item);
  }, [DangerNewEvaluation?.item, reset]);

  const onSubmit: SubmitHandler<WPDangerEvaluation> = (data) => {
    createMutate({
      token: tokenState,
      item: { ...initializeDangerEvaluation(parseInt(id!)), ...data },
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="작업위험성평가 작성" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DangerEvaluationForm captionColor="#01579B" />
          {/* <Button
              onClick={() => {
                navigate(`/Permission/CheckPermission/${res?.item?.uid}`, {state: res?.item});
              }}
            >
              저장 및 이동
            </Button> */}
          <ConfirmButtonGroup
            link="/Permission/List"
            cancelText="취소"
            confirmText="저장 및 세부항목 이동"
          />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateDangerEvaluation;
